import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridCellParams, GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import { Order } from '@/types/order';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';
import { transformDateString } from '@/utilities/datetime';
import { useGetChargeBack } from '@/hooks/order';

const getPaymentProviderDisplayName = (paymentProvider: string | null | undefined) => {
  if (!paymentProvider) {
    return '';
  }

  switch (paymentProvider) {
    case 'paypal':
      return 'PayPal';
    case 'adyen':
      return 'Adyen';
    default:
      return paymentProvider;
  }
};

const ChargeBack: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();

  const data = useGetChargeBack(order.orderId.toString());

  const columns: GridColDef[] = [
    { field: 'openDate', headerName: t('order.charge_back.open_date') },
    { field: 'outcome', headerName: t('order.charge_back.outcome') },
    {
      field: 'amount',
      headerName: t('order.charge_back.amount'),
      renderCell: (params: GridCellParams) => <div>{`${params.value} ${params.row.currency}`}</div>,
    },
    { field: 'reason', headerName: t('order.charge_back.reason') },
    {
      field: 'paymentProvider',
      headerName: t('order.charge_back.payment_provider'),
      renderCell: (params: GridCellParams<GridValidRowModel, string | null>) => (
        <div>{getPaymentProviderDisplayName(params.value)}</div>
      ),
    },
  ];

  const rows: GridValidRowModel[] =
    data.kind === 'Loaded'
      ? data.data.data.map((item) => {
          return {
            id: item.disputeId,
            orderId: item.orderId,
            openDate: transformDateString(item.disputeDateTimeParis, 'DD/MM/YYYY'),
            outcome: item.disputeOutcome,
            amount: item.disputeAmountLocal,
            currency: item.disputeCurrency,
            reason: item.disputeReason,
            paymentProvider: item.paymentProvider,
          };
        })
      : [];

  return (
    <Container
      title={t('order.charge_back.title')}
      actions={[]}
      testId="charge_back"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={false}
        table={{
          kind: 'Table',
        }}
      />
    </Container>
  );
};

export default ChargeBack;
